import { render, staticRenderFns } from "./product-review-answer.vue?vue&type=template&id=0982ff26&"
import script from "./product-review-answer.vue?vue&type=script&lang=js&"
export * from "./product-review-answer.vue?vue&type=script&lang=js&"
import style0 from "./product-review-answer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0982ff26')) {
      api.createRecord('0982ff26', component.options)
    } else {
      api.reload('0982ff26', component.options)
    }
    module.hot.accept("./product-review-answer.vue?vue&type=template&id=0982ff26&", function () {
      api.rerender('0982ff26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-review-answer.vue"
export default component.exports